import React from 'react'
import { IonButton, IonModal } from '@ionic/react'
import Api from "../services/Api"
import SmallModalHeader from './SmallModalHeader'

type Props = {
  walkId: number
  isOpen: boolean
  shareLink: any
  setShareLink: React.Dispatch<React.SetStateAction<any>>
}

export const ShareWalk = ({ isOpen, setShareLink, shareLink }: Props) => {
  const api = Api.getInstance();
  // const [shareLink, setShareLink] = useState({shareLink: '', shareUrlCopied: false})

  const copyToClipboard = (str: string) => {
    const el = document.createElement('textarea');
    el.value = str;
    el.setAttribute('readonly', '');
    el.style.position = 'absolute';
    el.style.left = '-9999px';
    document.body.appendChild(el);
    navigator.clipboard.writeText(el.value).then(() => {
      setShareLink({
        ...shareLink,
        shareUrlCopied: true
      })
    });
    document.body.removeChild(el);
  }

  return (
    <IonModal 
      isOpen={isOpen} 
      className='modal_small'
      onDidDismiss={() => setShareLink({
        ...shareLink,
        shareLink: ''
        })}>
      <div className="mx-4 text_center flex flex-col justify-around pos-relative">
        <SmallModalHeader
          pageTitle="Dela Promenaden"
          closeModal={() => setShareLink({
            shareLink: '', 
            shareUrlCopied: false})}/>
        <p className="mt-4">{api.tr('clicking_share_button')}</p>
        <div className="mt-4 infoArea">
          <a 
            target="_new" 
            href={shareLink.shareLink} 
            className="text_link">{ !shareLink.shareUrlCopied ? shareLink.shareLink : 'Länken är kopierad'}</a>
        </div>
        <IonButton 
          onClick={() => copyToClipboard(shareLink.shareLink)}
          class="smallButton" 
          size="small" 
          fill="outline">
          {api.tr('copy_link')}
        </IonButton>
      </div>
    </IonModal>
  )
}
